export default __webpack_public_path__ + "static/media/proj3_6.15c9ffe7.jpg";